var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 9.79694C11.617 9.79694 11.3056 10.0708 11.3056 10.408L11.3056 16.389C11.3056 16.7261 11.617 17 12.0003 17C12.3835 17 12.6949 16.7261 12.6949 16.389L12.6949 10.408C12.6949 10.0708 12.3835 9.79694 12.0003 9.79694ZM12.8472 7.86384C12.8472 7.38715 12.5512 7 12.0003 7C11.4494 7 11.1152 7.38715 11.1152 7.86384C11.1152 8.34317 11.4494 8.73031 12.0003 8.73031C12.5512 8.73031 12.8472 8.34317 12.8472 7.86384Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.4875 22 2 17.5125 2 12C2 6.4875 6.4875 2 12 2C17.5125 2 22 6.4875 22 12C22 17.5125 17.5125 22 12 22ZM12 3.45C7.28438 3.45 3.45 7.28438 3.45 12C3.45 16.7156 7.28438 20.55 12 20.55C16.7156 20.55 20.55 16.7156 20.55 12C20.55 7.28438 16.7156 3.45 12 3.45Z",
    fill: "currentColor"
  })));
};
export default SvgAttention;